import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { Contribution } from './../track/contribution';
import { ActivatedRoute, Router } from '@angular/router';
import { RegistryService } from './../registry/registry.service';
import { AuthService } from './../user/auth.service';
import { RegistryFirebaseService } from './../registry/registry-firebase.service';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { PaymentService } from '../payment/payment.service';
import { TrackedGiftCollection } from '../payment/tracked-gift-collection';
import { TrackedGift } from '../payment/tracked-gift';
import { SettingsService } from '../settings/settings.service';
import { Registry } from '../registry/registry';
import { ImageUrlService } from '../shared/services/image-url.service';


@Component({
  selector: 'app-track-detail',
  templateUrl: './track-detail.component.html',
  styleUrls: ['./track-detail.component.scss']
})
export class TrackDetailComponent implements OnInit, AfterViewInit {

  public hitchdForm: FormGroup;
  errorMessage: string;


  contributions: Contribution[];
  symbol: string;
  loaded = false;
  contributionId: string;
  contribution: Contribution;
  card: any;
  giftDeleteLimit = 5;
  sentDate: Date;
  minDate: Date;
  maxDate: Date;
  cardDelivery: any;
  uploadedImage: string;
  deleting = false;
  showDeleteConfirmation = false;
  remainingDeletes = 0;
  deletedContributions: Contribution[];
  registry: Registry;
  uploadText = 'Upload image from your trip';
  demoMode: boolean;

  demoContribution: any = {
    
      "applicationFee": 0,
      "createdDate": new Date(2024,3,23),
      "cart": [
          {
              "gift": {
                  "category": null,
                  "createdDate": null,
                  "createdFromGiftAssistant": null,
                  "paidAmount": 400,
                  "views": 0,
                  "cropParams": null,
                  "editing": false,
                  "removing": false,
                  "removingConfirmed": false,
                  "hex": "1",
                  "imageName": "gift_1",
                  "anonGiftId": null,
                  "mustBuyEntireGift": false,
                  campaign: null,
                  portions: null,
                  websiteLinkText: null,
                  "giftTemplateName": null,
                  "source": null,
                  "partnershipId": null,
                  "hideFundingProgress": false,           
                  "description": "After the big day, we'll be jetting away on our adventure of a lifetime.\n",
                  "descriptionTranslation": "",
                  "editedAfterGiftAssistant": null,
                  "featuredGift": null,
                  "friendlyUrl": "Flights",
                  "fromRegistry": "sample-gifts",
                  "fromTemplate": true,
                  "giftTypeSelection": "Experience",
                  "hidePrice": false,
                  "id": "K2DMcGrI0mipVNv8j1Tk",
                  "imageUrl": "https://images.unsplash.com/photo-1496686941088-eaa405ad5fbb",
                  "location": null,
                  "modifiedDate": 1680999870438,
                  "paidPercent": 51,
                  "price": 1000,
                  "pricePerPortion": 0,
                  "registryId": "fuIyeR1a25oYJvWdlL0i",
                  "remaining": 490,
                  "showGiftAmount": null,
                  "showTranslation": true,
                  "status": "active",
                
                  "templateGiftId": "gw8B18dvcDjKSFVCGrNA",
                  "title": "Flights",
                  "titleTranslation": "Le flight",
                  "type": "experience",
                  "userId": "zbmJg1e2eddV679bhlj3ziXT0Uv2",
                  "videoUrl": null,
                  "website": null
              },
              "giftId": "K2DMcGrI0mipVNv8j1Tk",
              "price": 400
          }
      ],
      "chargeTotal": 400,
      "coupleFee": 0,
      "coupleGets": 400,
      "giftTotal": 400,
      "guestEmail": "june@alexander.com",
      "guestFee": 0,
      "guestName": "June & Alexander",
      "guetsPays": 400,
      "isManualContribution": true,
   
      "manualPaymentMethod": "Stripe",
      
      "whenWillGuestPay": "now",
      "wish":{
        "wishText": "We're super excited for you both and couldn't resist chipping in for your big adventure! Imagine us cheering you on as you embark on this amazing journey together. Wishing you endless love and a ton of unforgettable moments."
      },
      "number": 7,
      "id": "explore",
      "friendlyPaymentMethod": "Stripe"
  
  
  }

  constructor(
    private _registryFirebaseService: RegistryFirebaseService,
    private _authService: AuthService,
    private _registryService: RegistryService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _fb: FormBuilder,
    private _paymentService: PaymentService,
    private imageUrlService: ImageUrlService
  ) {

    this.deleting = false;
    document.title = 'Contributions | Hitchd';
    this._route.params
      .subscribe(params => {

        this.contributionId = params['paymentId'];
        
        if (this.contributionId == 'explore') {
          this.demoMode = true;
          this.loaded = true;
          this._registryFirebaseService.currentRegistry.subscribe(registry => {
            if (registry) {
              this.symbol = registry.symbol;
            }

          });

          this._registryFirebaseService.killLoader();
          this.contribution = this.demoContribution;
        }
        this._registryFirebaseService.currentRegistry.subscribe(registry => {
          this.registry = registry;

      

          this._registryFirebaseService.killLoader();
        });


        this._authService.user.subscribe(user => {
          if (!user) {
            return;
          }
          if (this.demoMode){
            return;
          }
          this._registryFirebaseService.initGiftsForUser(user);
          this._registryFirebaseService.currentGifts.subscribe(gifts => {

            if (gifts) {


              this._registryFirebaseService.getCardSends(user.userId).subscribe(cards=>{
                this.card = cards.filter(x=>x.contributionId == this.contributionId)[0];
                if(this.card){
                this.cardDelivery = this.card.order.items[0].delivery;


                this.sentDate= new Date(this.cardDelivery.dispatch );
                this.maxDate = new Date(this.cardDelivery.estimatedMaxArrival );
                this.minDate = new Date(this.cardDelivery.estimatedMinArrival );
                }



              })
              if (this.demoMode){
                return;
              }
              this._registryFirebaseService.getContributions(gifts, this.registry).subscribe(contributions => {
                if (contributions) {
                  this.contribution = contributions.filter(x => x.id === this.contributionId)[0];

                  if (this.contribution) {

                    this.uploadedImage = this.contribution.coupleThankYouImageUrl;
                    // if (!this.contribution.coupleFee){
                    //   this.contribution.coupleFee = 0;
                    // }

                    // if (!this.contribution.guestFee){
                    //   this.contribution.coupleFee = 0;
                    // }
                  }
                  if (this.contribution && !this.contribution.seen) {

                    this._registryFirebaseService.updateContribution(this.contribution.id, this.contribution.coupleThankYou
                      , this.contribution.coupleThankYouImageUrl, true,  false);

                  }

                  this.loaded = true;



                }
              });

              if (this.demoMode){
                return;
              }
              this._registryFirebaseService.getDeletedContributions().subscribe(contributions => {
         
                if(contributions){
                  if(this.registry && this.registry.giftDeleteLimit ){
                    this.giftDeleteLimit = this.registry.giftDeleteLimit;
                  }

                  if (this.registry.tier == 'full'){
                    this.giftDeleteLimit = 100;
                    this.remainingDeletes = 100;
                  } else {
                    this.deletedContributions = contributions;
                    this.remainingDeletes = this.giftDeleteLimit - this.deletedContributions.length;
                  }

           
                }
              })
              
              if (this.demoMode){
                return;
              }
              this._registryFirebaseService.currentRegistry.subscribe(registry => {
                if (registry) {
                  this.symbol = registry.symbol;
                }

              });

            }
          });
        });
      });
  }

  deleteContribution(){
    if (this.contributionId){
      this.deleting = true;
      this._registryFirebaseService.markContributionAsDeleted(this.contribution).then(x=>{

this.deleting = false;
      });
      this._router.navigateByUrl('/registry/contributions')
    }
  }

  cleanCustomPaymentMethod(camelCaseString: string){
   
   let str = camelCaseString.replace(/([A-Z])/g, (match) => ` ${match}`).toLowerCase().trim();
   return str.charAt(0).toUpperCase() + str.slice(1);
  }

  expandTextArea(textArea: HTMLTextAreaElement) {
    textArea.rows = 1;
    const height = textArea.scrollHeight;
    textArea.rows = Math.floor(height / 26); // 20px = line-height: 1.25rem
    this.hitchdForm.markAsTouched();
  }


  thankYou(thankYouText: string, thankYouImageUrl: string) {
    this._registryFirebaseService.updateContribution(this.contributionId, thankYouText, thankYouImageUrl, true, false);



  }

  ngAfterViewInit(): void {
    window.scrollTo(0, 0);
    const textarea: HTMLTextAreaElement = <HTMLTextAreaElement>document.getElementById('introtext');
    //
    if (textarea) {
      textarea.value = textarea.value + '';
      this.expandTextArea(textarea);
    }

  }
  navigateToGift(url) {
    this._router.navigate(['/registry/' + url]
      , { queryParams: { from: 'contrib-detail' } });
  }
  handledUploadedImage(event: any) {
    if (event) {
      event = event + '?hex=ffffff';
    }
    this.uploadedImage = event;
  }

  getGiftUrlWithoutHex(imageUrl: string) {
    if (imageUrl) {
      return this._registryService.cleanImageUrlRemoveHex(imageUrl);
    }
  }

  color(imageUrl: string) {
    return this._registryService.getColor(imageUrl);
  }


  openUploader() {

    document.getElementById('file_input_id').click();
  }

  selectFirstName(fullName: string) {

    if (fullName) {
      return fullName.split(' ')[0];
    }
  }


  ngOnInit() {

    this.hitchdForm = this._fb.group({
      paymentId: [this.contributionId, [Validators.required]],
      thankYouImageUrl: [this.uploadedImage, []],
      message: ['', [Validators.required, Validators.minLength(1)]],
    });

  }

  submit() {
    if (this.hitchdForm.valid) {
      const message = this.hitchdForm.controls['message'].value;
      const paymentId = this.hitchdForm.controls['paymentId'].value;
      this._registryFirebaseService.updateContribution(paymentId, message, this.uploadedImage, true, false);

      let guestName = this.contribution.guestName;
      if (this.contribution.wish && this.contribution.wish.fullname) {

        guestName = this.contribution.wish.fullname;
        if (this.contribution.wish.partnersName) {
          guestName = this.selectFirstName(this.contribution.wish.fullname) + ' & '
            + this.selectFirstName(this.contribution.wish.partnersName);
        }

      }


      let giftNames = '';
      for (let i = 0, len = this.contribution.cart.length; i < len; i++) {
        if (giftNames !== '' && i < (len - 1)) {
          giftNames = giftNames + ', ';
        } else if (len > 1 && i === (len - 1)) {
          giftNames = giftNames + ' and ';
        }
        giftNames = giftNames + this.contribution.cart[i].gift.title;
      }


      const emailRequest: any = {
        registryId: this.registry.id,
        giftNames: giftNames,
        guestNames: guestName,
        thankyouText: message,
        thankyouImage: this.uploadedImage,
        giftTotal: this.contribution.giftTotal,
        coupleNames: this.registry.firstName + ' & ' + this.registry.partnerFirstName,
        guestEmail: this.contribution.guestEmail,
        totalAmount: this.contribution.giftTotal + this.contribution.guestFee,
        guestFee: this.contribution.guestFee,
        symbol: this.registry.symbol
      };
      this._paymentService.SendThankYouEmail(JSON.stringify(emailRequest)).subscribe(x => {

      });
    }

  }

  getStandardImageUrl(imageUrl: string): string {
    return this.imageUrlService.getStandardImageUrl(imageUrl);
  }
}




// WEBPACK FOOTER //
// ./src/app/track-detail/track-detail.component.ts